import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, isLoading } = useAuth();
  if (isLoading) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center bg-[var(--mp-bg)] text-[var(--mp-muted)]"
      >
        <div className="flex items-center gap-3">
          <span className="inline-block h-3 w-3 rounded-full bg-[var(--mp-primary)] animate-pulse" />
          <span className="font-body">Caricamento…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
